// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__3Q7Jg","image":"Logo_image__dpcR9","text":"Logo_text__2qawT","name":"Logo_name__2fT1r","tagline":"Logo_tagline___QLgx"};